import React, { useEffect, useState } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import Handler from '../../Helpers/Components/Handler';
import { useNavigate } from 'react-router-dom';

const Availability = (props) => {
    const localizer = momentLocalizer(moment);
    const [bookingList, setBookingList] = useState([]);
    const [events, setEvents] = useState([])
    const navigate = useNavigate()
    const eventStyleGetter = (event) => {
        return {
            style: {
                backgroundColor: event?.name === "Booked" ? "yellow" :
                    event?.name === "Ongoing" || "Started" ? "green" :
                        event?.name === "Pending" ? "red" : "",
                color: event?.name === "Booked" ? "black" : 'white',
            },
        }
    }
    const getBookingList = async () => {
        const booking = await Handler({ method: 'post', url: `/booking/available`, data: { } })
        if (booking?.success) {
            setBookingList(booking?.data)
        } else {
            setBookingList([])
        }
    }
    const setEvent = () => {
        setEvents(bookingList?.map((element) => {
            return {
                title: element?.carId,
                start: new Date(new Date(element?.deliveryDetails?.delivery).getFullYear(), new Date(element?.deliveryDetails?.delivery).getMonth(), new Date(element?.deliveryDetails?.delivery).getDate(), new Date(element?.deliveryDetails?.delivery).getHours(), new Date(element?.deliveryDetails?.delivery).getMinutes()),
                end: new Date(new Date(element?.pickupDetails?.pickup).getFullYear(), new Date(element?.pickupDetails?.pickup).getMonth(), new Date(element?.pickupDetails?.pickup).getDate(), new Date(element?.pickupDetails?.pickup).getHours(), new Date(element?.pickupDetails?.pickup).getMinutes()),
                name: element?.status
            }
        }))
    }
    useEffect(() => {
        getBookingList();
    }, [])
    useEffect(() => {
        if (bookingList?.length > 0) {
            setEvent();
        }
    }, [bookingList])
    return (
            <React.Fragment>
            <div className="arrow-back"><i onClick={() => navigate(-1)} className="fa-solid fa-arrow-left fs-5 cursor-pointer"></i></div>
                    <div className='mt-4 align-items-center justify-content-center row'>
                        <div className='calendarView mb-5 col-md-9'>
                            <Calendar
                                localizer={localizer}
                                events={events}
                                startAccessor="start"
                                endAccessor="end"
                                defaultView="month"
                                eventPropGetter={eventStyleGetter}
                            />
                        </div>
                    </div>
                
            </React.Fragment>
    );
};

export default Availability;
